const domainPersonEn = {
  peole: "people",
  unit: "people",
};

export default domainPersonEn;
